import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';

import type { IconName } from '@core/user-interface-legacy';
import {
  BadgeComponent,
  HeadingComponent,
  IconComponent,
  RtTooltip,
} from '@core/user-interface-legacy';

export enum CounterTypes {
  CounterWithLabel,
  CounterWithIcon,
  CounterWithBudget,
}

interface CounterOptions {
  iconName?: IconName;
}

export interface Counter {
  value: string | number;
  label: string;
  type: CounterTypes;
  options?: CounterOptions;
  isVisible: boolean;
}

@Component({
  selector: 'rt-offers-footer-counters',
  templateUrl: './offers-footer-counters.component.html',
  styleUrls: ['./offers-footer-counters.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [HeadingComponent, BadgeComponent, RtTooltip, IconComponent],
})
export class OffersFooterCountersComponent {
  protected readonly CounterTypes = CounterTypes;

  public counters = input.required<Counter[]>();

  protected visibleCounters = computed(() => this.counters().filter(counter => counter.isVisible));
}
